export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fbe362d86853bc57ba806b5e70af84418566a2acb&name=fetchTypeahead!'